var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLeonInmobiliariaIconsArrow1Down = function SvgLeonInmobiliariaIconsArrow1Down(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".leon-inmobiliaria-icons-arrow-1-down_svg__st0{fill:currentcolor}.leon-inmobiliaria-icons-arrow-1-down_svg__st1{display:none}.leon-inmobiliaria-icons-arrow-1-down_svg__st2{fill:currentcolor}.leon-inmobiliaria-icons-arrow-1-down_svg__st2,.leon-inmobiliaria-icons-arrow-1-down_svg__st3{display:inline}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "leon-inmobiliaria-icons-arrow-1-down_svg__st0",
    d: "M82.9 27.5 50 60.4 17.1 27.5l-6.1 6 39 39 39-39z",
    id: "leon-inmobiliaria-icons-arrow-1-down_svg__Arrow_01"
  })));
};
export default SvgLeonInmobiliariaIconsArrow1Down;